export const uk = {
    'product-description-cannot-be-more-than-max': {
        one: 'Описание продукта не должно превышать {maxLength} символ',
        some: 'Описание продукта не должно превышать {maxLength} символа',
        many: 'Описание продукта не должно превышать {maxLength} символов',
        none: 'Описание продукта не должно превышать {maxLength} символов'
    },
    'product-name-cannot-be-more-than-max': {
        one: 'Название продукта не должно превышать {maxLength} символ',
        some: 'Название продукта не должно превышать {maxLength} символа',
        many: 'Название продукта не должно превышать {maxLength} символов',
        none: 'Название продукта не должно превышать {maxLength} символов'
    },
    'product-with-this-name-already-exists': 'Продукт с таким названием уже существует',
    'unknown-error-text': 'Не удалось обновить продукт'
};
